module.exports = __webpack_public_path__ + "static/media/water_bill_2.47efaaec.svg";